.title {
	color: var(--ds-text-subtlest, var(--adg3-color-subtleText-light));
	text-transform: uppercase;
	font-weight: 600;
	font-size: 11px;
	padding: 0 var(--jpo-common-base-spacing);
	line-height: calc(var(--jpo-common-base-spacing) * 4);
	display: inline-block;
	margin-top: -2px;
}
